import axios from '@/js/plugins/client'
export default {
  alias      : 'tramite_firma_token',
  route      : '/app/tramite/firma_token',
  hash       : false,
  store      : false,
  key        : 'id',
  name       : 'token',
  selectable : false,
  default    : {
    id         : null,
    token      : null,
    estado     : 1,
    lote       : true,
    files      : [],
    origen     : 1,
    updated_at : null,
    created_at : null
  },
  methods : {
    saveExternal(params) {
      return new Promise((resolve, reject) => {
        axios.post('/firmaperu/store_temp', params).then(response => {
          resolve(response)
        })
          .catch(reject)
      })
    },
  }
}
